import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import ReactToPrint from "react-to-print";

const componentRef = React.createRef();
// var QRCode = require("qrcode.react");

const css = `
  @media print {
    @page {
      size: A3 landscape !important;
    }
  } 
`;

class HojaRemisionMuestra extends React.Component {
  render() {
    return (
      <>
        <style>{css}</style>
        <Modal
          isOpen={this.props.modalHojaRemisionMuestra}
          modalClassName="modal-message"
        >
          <ModalHeader>
            <div>
              Visita: {this.props.folio_visita}
              <button
                type="button"
                className="close"
                onClick={this.props.closeModalHojaRemision}
                style={{ position: "fixed", right: "21%" }}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
          </ModalHeader>
          <ModalBody>
            <div className={this.props.working ? "" : "hide"}>
              <div className="progress-bar bg-orange progress-bar-striped progress-bar-animated">
                CARGANDO INFORMACIÓN
              </div>
            </div>

            <div className={this.props.working ? "hide" : ""}>
              {/* Aquí va codigo del documento */}

              <div
                className="row"
                ref={componentRef}
                style={{ background: "white" }}
              >
                <form
                  style={{
                    marginRight: "13%",
                    marginLeft: "13%",
                    overflow: "auto",
                    color: "black",
                    width: "100%",
                  }}
                >
                  <div className="pdf-header">
                    <table
                      className="table"
                      style={{
                        width: "100%",
                        marginBottom: "1rem",
                        marginTop: "2rem",
                        color: "#212529",
                        borderSpacing: 0,
                        borderCollapse: "collapse",
                        tableLayout: "auto",
                      }}
                    >
                      <tbody>
                        <tr
                          className="text-center"
                          style={{ textAlign: "center" }}
                        >
                          <td
                            style={{
                              padding: ".5rem",
                              verticalAlign: "top",
                            }}
                            width="25%"
                          >
                            <img
                              src="../assets/gobierno-logo.png"
                              alt="Logo Gobierno"
                            />
                          </td>
                          <td
                            style={{
                              padding: ".5rem",
                              verticalAlign: "top",
                            }}
                            width="50%"
                          >
                            <strong>
                              Instituto de Protección y Sanidad Agropecuraria
                              IPSA <br />
                              Dirección de salud Animal <br />
                              Hoja de Remisión de Muestra
                            </strong>
                          </td>
                          <td
                            style={{
                              padding: ".5rem",
                              verticalAlign: "top",
                            }}
                            width="25%"
                          >
                            <img
                              src="../assets/ipsa-logo.png"
                              alt="Logo IPSA"
                            />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <div className="pdf-general-data">
                    <table
                      className="table"
                      style={{
                        width: "100%",
                        marginTop: "2rem",
                        marginBottom: "1rem",
                        color: "#212529",
                        borderSpacing: 0,
                        borderCollapse: "collapse",
                        tableLayout: "auto",
                      }}
                    >
                      <thead>
                        <tr>
                          <td
                            colSpan="3"
                            className="table-header-td text-center"
                            style={{
                              backgroundColor: "#dcdcdc",
                              textAlign: "center",
                              padding: 0,
                              verticalAlign: "top",
                            }}
                          >
                            <b>I. Datos Generales</b>
                          </td>
                        </tr>
                      </thead>

                      <tbody>
                        <tr>
                          <td
                            width="33.333%"
                            colSpan="1"
                            className="table-body-td no-border"
                            style={{ padding: 0 }}
                          >
                            <p className="m-0" style={{ margin: 0 }}>
                              <span
                                className="mr-2"
                                style={{ marginRight: "0.5rem" }}
                              >
                                <b>*Laboratorio:</b>
                              </span>
                              {
                                this.props.remisionMuestra.laboratorio
                                  .descripcion
                              }
                            </p>
                          </td>
                          <td
                            width="33.333%"
                            colSpan="1"
                            className="table-body-td no-border"
                            style={{ padding: 0 }}
                          >
                            <p className="m-0" style={{ margin: 0 }}>
                              <span
                                className="mr-2"
                                style={{ marginRight: "0.5rem" }}
                              >
                                <b>*Marchamos:</b>
                              </span>
                              {this.props.remisionMuestra.marchamos || "---"}
                            </p>
                          </td>
                          <td
                            width="33.333%"
                            colSpan="1"
                            className="table-body-td no-border"
                            style={{ padding: 0 }}
                          >
                            <p className="m-0" style={{ margin: 0 }}>
                              <span
                                className="mr-2"
                                style={{ marginRight: "0.5rem" }}
                              >
                                <b>*Remitente/Ordenado por:</b>
                              </span>
                              {this.props.remisionMuestra.remitente.nombre}
                            </p>
                          </td>
                        </tr>

                        <tr>
                          <td
                            className="table-body-td no-border"
                            style={{ padding: 0 }}
                          >
                            <p className="m-0" style={{ margin: 0 }}>
                              <span
                                className="mr-2"
                                style={{ marginRight: "0.5rem" }}
                              >
                                <b>
                                  *N<sup>o</sup>/Fecha/Hora Remisión:
                                </b>
                              </span>
                              {`${this.props.remisionMuestra.no_remision} |
                            ${this.props.remisionMuestra.fecha_remision
                              .split("-")
                              .reverse()
                              .join("/")}
                            | ${this.props.remisionMuestra.hora_remision.substr(
                              0,
                              5
                            )}`}
                            </p>
                          </td>
                          <td
                            className="table-body-td no-border"
                            style={{ padding: 0 }}
                          >
                            <p className="m-0" style={{ margin: 0 }}>
                              <span
                                className="mr-2"
                                style={{ marginRight: "0.5rem" }}
                              >
                                <b>*Colector:</b>
                              </span>
                              {this.props.remisionMuestra.colector.nombre}
                            </p>
                          </td>
                          <td
                            className="table-body-td no-border"
                            style={{ padding: 0 }}
                          >
                            <p className="m-0" style={{ margin: 0 }}>
                              <span
                                className="mr-2"
                                style={{ marginRight: "0.5rem" }}
                              >
                                <b>*Tel/Remitente:</b>
                              </span>
                              {this.props.remisionMuestra.remitente.telefono}
                            </p>
                          </td>
                        </tr>

                        <tr>
                          <td
                            colSpan="1"
                            className="table-body-td no-border"
                            style={{ padding: 0 }}
                          >
                            <p className="m-0" style={{ margin: 0 }}>
                              <span
                                className="mr-2"
                                style={{ marginRight: "0.5rem" }}
                              >
                                <b>*Solicitante/Propietario:</b>
                              </span>
                              {this.props.remisionMuestra.solicitante
                                ? this.props.remisionMuestra.solicitante
                                    .razon_social
                                : this.props.remisionMuestra.nombre_razon}
                            </p>
                          </td>
                          <td
                            colSpan="2"
                            className="table-body-td no-border"
                            style={{ padding: 0 }}
                          >
                            <p className="m-0" style={{ margin: 0 }}>
                              <span
                                className="mr-2"
                                style={{ marginRight: "0.5rem" }}
                              >
                                <b>*Teléfono Consignatario/Propietario:</b>
                              </span>
                              {this.props.remisionMuestra.solicitante
                                ? this.props.remisionMuestra.solicitante
                                    .telefono
                                : "---"}
                            </p>
                          </td>
                        </tr>

                        <tr>
                          <td
                            colSpan="1"
                            className="table-body-td no-border"
                            style={{ padding: 0 }}
                          >
                            <p className="m-0" style={{ margin: 0 }}>
                              <span
                                className="mr-2"
                                style={{ marginRight: "0.5rem" }}
                              >
                                <b>*Dirección:</b>
                              </span>
                              {this.props.remisionMuestra.solicitante
                                ? this.props.remisionMuestra.solicitante
                                    .direccion
                                : "---"}
                            </p>
                          </td>
                          <td
                            colSpan="1"
                            className="table-body-td no-border"
                            style={{ padding: 0 }}
                          >
                            <p className="m-0" style={{ margin: 0 }}>
                              <span
                                className="mr-2"
                                style={{ marginRight: "0.5rem" }}
                              >
                                <b>*Departamento:</b>
                              </span>
                              {this.props.remisionMuestra.solicitante
                                ? this.props.remisionMuestra.solicitante
                                    .departamento
                                : "---"}
                            </p>
                          </td>
                          <td
                            colSpan="1"
                            className="table-body-td no-border"
                            style={{ padding: 0 }}
                          >
                            <p className="m-0" style={{ margin: 0 }}>
                              <span
                                className="mr-2"
                                style={{ marginRight: "0.5rem" }}
                              >
                                <b>*Municipio:</b>
                              </span>
                              {this.props.remisionMuestra.solicitante
                                ? this.props.remisionMuestra.solicitante
                                    .municipio
                                : "---"}
                            </p>
                          </td>
                        </tr>

                        <tr>
                          <td
                            colSpan="1"
                            className="table-body-td no-border"
                            style={{ padding: 0 }}
                          >
                            <p className="m-0" style={{ margin: 0 }}>
                              <span
                                className="mr-2"
                                style={{ marginRight: "0.5rem" }}
                              >
                                <b>*Lugar de Muestreo/Finca/Planta:</b>
                              </span>
                              {this.props.remisionMuestra.lugar_muestreo ||
                                "---"}
                            </p>
                          </td>
                          <td
                            colSpan="1"
                            className="table-body-td no-border"
                            style={{ padding: 0 }}
                          >
                            <p className="m-0" style={{ margin: 0 }}>
                              <span
                                className="mr-2"
                                style={{ marginRight: "0.5rem" }}
                              >
                                <b>*CUE/Cód. IPSA:</b>
                              </span>
                              {this.props.remisionMuestra.cue_cod_ipsa || "---"}
                            </p>
                          </td>
                          <td
                            colSpan="1"
                            className="table-body-td no-border"
                            style={{ padding: 0 }}
                          >
                            <p className="m-0" style={{ margin: 0 }}>
                              <span
                                className="mr-2"
                                style={{ marginRight: "0.5rem" }}
                              >
                                <b>*Comarca:</b>
                              </span>
                              {this.props.remisionMuestra.comarca || "---"}
                            </p>
                          </td>
                        </tr>

                        <tr>
                          <td
                            colSpan="3"
                            className="table-body-td no-border"
                            style={{ padding: 0 }}
                          >
                            <p className="m-0" style={{ margin: 0 }}>
                              <span
                                className="mr-2"
                                style={{ marginRight: "0.5rem" }}
                              >
                                <b>*Otro Propietario:</b>
                              </span>
                              {this.props.remisionMuestra.otro_propietario ||
                                "---"}
                            </p>
                          </td>
                        </tr>
                      </tbody>
                    </table>

                    <hr
                      style={{
                        borderTop: "1px solid black",
                      }}
                    />

                    <table
                      className="table"
                      style={{
                        width: "100%",
                        marginTop: "1rem",
                        marginBottom: "1rem",
                        color: "#212529",
                        borderSpacing: 0,
                        borderCollapse: "collapse",
                        tableLayout: "auto",
                      }}
                    >
                      <tbody>
                        <tr>
                          <td
                            colSpan="3"
                            className="table-body-td no-border"
                            style={{
                              padding: 0,
                              verticalAlign: "top",
                            }}
                          >
                            <p className="m-0" style={{ margin: 0 }}>
                              <span
                                className="mr-2"
                                style={{ marginRight: "0.5rem" }}
                              >
                                <b>*Observaciones:</b>
                              </span>
                              {this.props.remisionMuestra.vdt2.observaciones ||
                                "---"}
                            </p>
                          </td>
                        </tr>
                      </tbody>
                    </table>

                    <hr
                      style={{
                        borderTop: "1px dotted black",
                      }}
                    />

                    {/*<table
                    className="table"
                    style={{
                      width: "100%",
                      marginBottom: "1rem",
                      color: "#212529",
                      borderSpacing: 0,
                      borderCollapse: "collapse",
                      tableLayout: "auto",
                    }}
                  >
                    <tbody>
                      <tr>
                        <td
                          width="33.333%"
                          colSpan="1"
                          className="table-body-td no-border"
                          style={{
                            padding: 0,
                            verticalAlign: "top",
                          }}
                        >
                          <p className="m-0" style={{ margin: 0 }}>
                            <span
                              className="mr-2"
                              style={{ marginRight: "0.5rem" }}
                            >
                              <b>
                                *N<sup>o</sup> Solicitud:
                              </b>
                            </span>
                            {this.props.remisionMuestra.no_solicitud}
                          </p>
                        </td>
                        <td
                          width="33.333%"
                          colSpan="1"
                          className="table-body-td no-border"
                          style={{
                            padding: 0,
                            verticalAlign: "top",
                          }}
                        >
                          <p className="m-0" style={{ margin: 0 }}>
                            <span
                              className="mr-2"
                              style={{ marginRight: "0.5rem" }}
                            >
                              <b>*Fecha y Hora de Recepción:</b>
                            </span>
                            {/*`${this.props.remisionMuestra.fecha_remision
                              .split("-")
                              .reverse()
                              .join(
                                "/"
                              )} | ${this.props.remisionMuestra.hora_remision.substr(
                              0,
                              5
                              )}`}
                          </p>
                        </td>
                        <td
                          width="33.333%"
                          colSpan="1"
                          className="table-body-td no-border"
                          style={{
                            padding: 0,
                            verticalAlign: "top",
                          }}
                        >
                          <p className="m-0" style={{ margin: 0 }}>
                            <span
                              className="mr-2"
                              style={{ marginRight: "0.5rem" }}
                            >
                              <b>
                                *N<sup>o</sup> Recibo:
                              </b>
                            </span>
                            {this.props.remisionMuestra.no_recibo || "---"}
                          </p>
                        </td>
                      </tr>

                      <tr>
                        <td
                          colSpan="1"
                          className="table-body-td no-border"
                          style={{
                            padding: 0,
                            verticalAlign: "top",
                          }}
                        >
                          <p className="m-0" style={{ margin: 0 }}>
                            <span
                              className="mr-2"
                              style={{ marginRight: "0.5rem" }}
                            >
                              <b>*Recepcionado por:</b>
                            </span>
                            {
                              this.props.remisionMuestra.vdt2
                                .nombre_recibe_laboratorio
                            }
                          </p>
                        </td>
                        <td
                          colSpan="1"
                          className="table-body-td no-border"
                          style={{
                            padding: 0,
                            verticalAlign: "top",
                          }}
                        >
                          <p className="m-0" style={{ margin: 0 }}>
                            <span
                              className="mr-2"
                              style={{ marginRight: "0.5rem" }}
                            >
                              <b>*Fecha probable de entrega:</b>
                            </span>
                            {this.props.remisionMuestra.fecha_probable_entrega
                              .split("-")
                              .reverse()
                            .join("/")}
                          </p>
                        </td>
                        <td
                          colSpan="1"
                          className="table-body-td no-border"
                          style={{
                            padding: 0,
                            verticalAlign: "top",
                          }}
                        >
                          <p className="m-0" style={{ margin: 0 }}>
                            <span
                              className="mr-2"
                              style={{ marginRight: "0.5rem" }}
                            >
                              <b>*Monto/Moneda:</b>
                            </span>
                            {this.props.remisionMuestra.monto || "---"}
                          </p>
                        </td>
                      </tr>

                      
                    </tbody>
                          </table>*/}

                    <hr />
                  </div>

                  <div className="pdf-muestra-data">
                    <table
                      className="table"
                      style={{
                        width: "100%",
                        marginBottom: 0,
                        color: "#212529",
                        borderSpacing: 0,
                        borderCollapse: "collapse",
                        tableLayout: "auto",
                      }}
                    >
                      <thead>
                        <tr>
                          <td
                            colSpan="3"
                            className="table-header-td text-center"
                            style={{
                              backgroundColor: "#dcdcdc",
                              textAlign: "center",
                              padding: 0,
                              verticalAlign: "top",
                            }}
                          >
                            <b>II. Datos Muestra</b>
                          </td>
                        </tr>
                      </thead>
                    </table>

                    <table
                      className="table table-1-1"
                      style={{
                        width: "100%",
                        marginBottom: "1rem",
                        color: "#212529",
                        borderSpacing: 0,
                        borderCollapse: "collapse",
                        tableLayout: "auto",
                      }}
                    >
                      <tbody>
                        <tr className="table-1-1-tr">
                          <td
                            width="33.333%"
                            colSpan="1"
                            className="table-body-td table-1-1-td no-border"
                            style={{
                              padding: 0,
                              verticalAlign: "top",
                            }}
                          >
                            <p className="m-0" style={{ margin: 0 }}>
                              <span
                                className="mr-2"
                                style={{ marginRight: "0.5rem" }}
                              >
                                <b>
                                  *N<sup>o</sup> Remisión:
                                </b>
                              </span>
                              {this.props.remisionMuestra.no_remision}
                            </p>
                          </td>
                          <td
                            width="33.333%"
                            colSpan="1"
                            className="table-body-td table-1-1-td no-border"
                            style={{
                              padding: 0,
                              verticalAlign: "top",
                            }}
                          >
                            <p className="m-0" style={{ margin: 0 }}>
                              <span
                                className="mr-2"
                                style={{ marginRight: "0.5rem" }}
                              >
                                <b>*Uso/Proposito:</b>
                              </span>
                              {this.props.remisionMuestra.proposito || "---"}
                            </p>
                          </td>
                          <td
                            width="33.333%"
                            colSpan="1"
                            className="table-body-td table-1-1-td no-border"
                            style={{
                              padding: 0,
                              verticalAlign: "top",
                            }}
                          >
                            <p className="m-0" style={{ margin: 0 }}>
                              <span
                                className="mr-2"
                                style={{ marginRight: "0.5rem" }}
                              >
                                <b>*Lote:</b>
                              </span>
                              {this.props.remisionMuestra.lote || "---"}
                            </p>
                          </td>
                        </tr>

                        <tr>
                          <td
                            colSpan="1"
                            className="table-body-td table-1-1-td no-border"
                            style={{
                              padding: 0,
                              verticalAlign: "top",
                            }}
                          >
                            <p className="m-0" style={{ margin: 0 }}>
                              <span
                                className="mr-2"
                                style={{ marginRight: "0.5rem" }}
                              >
                                <b>*Fecha y Hora de Toma de Muestra:</b>
                              </span>
                              {`${this.props.remisionMuestra.fecha
                                .split("-")
                                .reverse()
                                .join(
                                  "/"
                                )} | ${this.props.remisionMuestra.hora_inicio.substr(
                                0,
                                5
                              )}`}
                            </p>
                          </td>
                          {/*<td
                          colSpan="1"
                          className="table-body-td table-1-1-td no-border"
                          style={{
                            padding: 0,
                            verticalAlign: "top",
                          }}
                        >
                          <p className="m-0" style={{ margin: 0 }}>
                            <span
                              className="mr-2"
                              style={{ marginRight: "0.5rem" }}
                            >
                              <b>*Temperatura de Levantamiento:</b>
                            </span>
                            {this.props.remisionMuestra
                              .temperatura_levantamiento
                              ? `${parseFloat(
                                  this.props.remisionMuestra
                                    .temperatura_levantamiento
                                )} C°`
                              : "---"}
                          </p>
                              </td>*/}
                          <td
                            colSpan="1"
                            className="table-body-td table-1-1-td no-border"
                            style={{
                              padding: 0,
                              verticalAlign: "top",
                            }}
                          >
                            <p className="m-0" style={{ margin: 0 }}>
                              <span
                                className="mr-2"
                                style={{ marginRight: "0.5rem" }}
                              >
                                <b>
                                  *No<sup>o</sup> Muestras:
                                </b>
                              </span>
                              {this.props.remisionMuestra.no_muestras}
                            </p>
                          </td>
                        </tr>

                        <tr>
                          <td
                            colSpan="1"
                            className="table-body-td table-1-1-td no-border"
                            style={{
                              padding: 0,
                              verticalAlign: "top",
                            }}
                          >
                            <p className="m-0" style={{ margin: 0 }}>
                              <span
                                className="mr-2"
                                style={{ marginRight: "0.5rem" }}
                              >
                                <b>*Clasificación:</b>
                              </span>
                              {this.props.remisionMuestra
                                .clasificacion_zootecnica || "---"}
                            </p>
                          </td>
                          {/*<td
                          colSpan="1"
                          className="table-body-td table-1-1-td no-border"
                          style={{
                            padding: 0,
                            verticalAlign: "top",
                          }}
                        >
                          <p className="m-0" style={{ margin: 0 }}>
                            <span
                              className="mr-2"
                              style={{ marginRight: "0.5rem" }}
                            >
                              <b>*Crianza:</b>
                            </span>
                            ---
                          </p>
                        </td>*/}
                          <td
                            colSpan="1"
                            className="table-body-td table-1-1-td no-border"
                            style={{
                              padding: 0,
                              verticalAlign: "top",
                            }}
                          >
                            <p className="m-0" style={{ margin: 0 }}>
                              <span
                                className="mr-2"
                                style={{ marginRight: "0.5rem" }}
                              >
                                <b>*Fecha de Producción/Elaboración:</b>
                              </span>
                              {`${this.props.remisionMuestra.fecha
                                .split("-")
                                .reverse()
                                .join("/")}` || "---"}
                            </p>
                          </td>

                          <td
                            colSpan="1"
                            className="table-body-td table-1-1-td no-border"
                            style={{
                              padding: 0,
                              verticalAlign: "top",
                            }}
                          >
                            <p className="m-0" style={{ margin: 0 }}>
                              <span
                                className="mr-2"
                                style={{ marginRight: "0.5rem" }}
                              >
                                <b>*Fecha de vencimiento:</b>
                              </span>
                              {this.props.remisionMuestra.fecha_vencimiento
                                ? `${this.props.remisionMuestra.fecha_vencimiento
                                    .split("-")
                                    .reverse()
                                    .join("/")}`
                                : "---"}
                            </p>
                          </td>
                        </tr>

                        {/*<tr>
                        <td
                          colSpan="3"
                          className="table-body-td table-1-1-td no-border text-center mt-0"
                          style={{
                            padding: 0,
                            border: "none",
                            textAlign: "center",
                            verticalAlign: "top",
                            marginTop: 0,
                          }}
                        >
                          <p className="mb-0" style={{ marginBottom: 0 }}>
                            <b>
                              <u>Uso Laboratorio</u>
                            </b>
                          </p>
                        </td>
                      </tr>

                      <tr>
                        <td
                          width="33.333%"
                          colSpan="1"
                          className="table-body-td table-1-1-td no-border"
                          style={{
                            padding: 0,
                            verticalAlign: "top",
                          }}
                        >
                          <p className="m-0" style={{ margin: 0 }}>
                            <span
                              className="mr-2"
                              style={{ marginRight: "0.5rem" }}
                            >
                              <b>
                                *N<sup>o</sup> de Solicitud:
                              </b>
                            </span>
                            {this.props.remisionMuestra.no_solicitud}
                          </p>
                        </td>
                        <td
                          width="33.333%"
                          colSpan="1"
                          className="table-body-td table-1-1-td no-border"
                          style={{
                            padding: 0,
                            verticalAlign: "top",
                          }}
                        >
                          <p className="m-0" style={{ margin: 0 }}>
                            <span
                              className="mr-2"
                              style={{ marginRight: "0.5rem" }}
                            >
                              <b>*Temperatura de Ingreso:</b>
                            </span>
                            {this.props.remisionMuestra.temperatura_ingreso
                              ? `${parseFloat(
                                  this.props.remisionMuestra.temperatura_ingreso
                                )} C°`
                              : "---"}
                          </p>
                        </td>
                        <td
                          width="33.333%"
                          colSpan="1"
                          className="table-body-td table-1-1-td no-border"
                          style={{
                            padding: 0,
                            verticalAlign: "top",
                          }}
                        >
                          <p className="m-0" style={{ margin: 0 }}>
                            <span
                              className="mr-2"
                              style={{ marginRight: "0.5rem" }}
                            >
                              <b>*Fecha y Hora de Recepción:</b>
                            </span>
                            {this.props.remisionMuestra.hora_remision
                              ? `${this.props.remisionMuestra.fecha_remision
                                  .split("-")
                                  .reverse()
                                  .join(
                                    "/"
                                  )} | ${this.props.remisionMuestra.hora_remision.substr(
                                  0,
                                  5
                                )}`
                              : `${this.props.remisionMuestra.fecha_remision
                                  .split("-")
                                  .reverse()
                              .join("/")}`}
                          </p>
                        </td>
                      </tr>

                      <tr>
                        <td
                          colSpan="3"
                          className="table-body-td table-1-1-td no-border"
                          style={{
                            padding: 0,
                            verticalAlign: "top",
                          }}
                        >
                          <p className="m-0" style={{ margin: 0 }}>
                            <span
                              className="mr-2"
                              style={{ marginRight: "0.5rem" }}
                            >
                              <b>*Recibido por:</b>
                            </span>
                            {
                              this.props.remisionMuestra.vdt2
                                .nombre_recibe_laboratorio
                            }
                          </p>
                        </td>
                          </tr>*/}
                      </tbody>
                    </table>

                    <table
                      className="table table-1-2 text-center"
                      style={{
                        borderCollapse: "collapse",
                        paddingLeft: "3rem",
                        border: "1px solid #dcdcdc",
                        padding: 0,
                        fontSize: "13px",
                        textAlign: "center",
                        width: "100%",
                        marginBottom: "1rem",
                        color: "#212529",
                        borderSpacing: 0,
                        tableLayout: "auto",
                      }}
                    >
                      <thead>
                        <tr>
                          <th
                            width="5%"
                            style={{
                              padding: 0,
                              fontSize: "13px",
                              border: "1px solid #dcdcdc",
                            }}
                          >
                            ID Mx
                          </th>

                          <th
                            width="10%"
                            style={{
                              padding: 0,
                              fontSize: "13px",
                              border: "1px solid #dcdcdc",
                            }}
                          >
                            Producto
                          </th>

                          <th
                            width="10%"
                            style={{
                              padding: 0,
                              fontSize: "13px",
                              border: "1px solid #dcdcdc",
                            }}
                          >
                            Tipo de Muestra
                          </th>
                          <th
                            width="10%"
                            style={{
                              padding: 0,
                              fontSize: "13px",
                              border: "1px solid #dcdcdc",
                            }}
                          >
                            Observaciones
                          </th>

                          <th
                            width="5%"
                            style={{
                              padding: 0,
                              fontSize: "13px",
                              border: "1px solid #dcdcdc",
                            }}
                          >
                            Unidad de Medida Muestra
                          </th>
                          <th
                            width="25%"
                            style={{
                              padding: 0,
                              fontSize: "13px",
                              border: "1px solid #dcdcdc",
                            }}
                          >
                            Análisis Solicitado
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td
                            style={{
                              border: "1px solid #dcdcdc",
                              verticalAlign: "top",
                            }}
                          >
                            {this.props.remisionMuestra
                              .rel_remision_visita_muestra.id_mx || "N/A"}
                          </td>

                          <td
                            style={{
                              border: "1px solid #dcdcdc",
                              verticalAlign: "top",
                            }}
                          >
                            {this.props.remisionMuestra.tipo_muestra || "N/A"}
                          </td>
                          <td
                            style={{
                              border: "1px solid #dcdcdc",
                              verticalAlign: "top",
                            }}
                          >
                            {this.props.remisionMuestra
                              .forma_comercializacion || "N/A"}
                          </td>
                          <td
                            style={{
                              border: "1px solid #dcdcdc",
                              verticalAlign: "top",
                            }}
                          >
                            {this.props.remisionMuestra
                              .rel_remision_visita_muestra.observacion || "N/A"}
                          </td>
                          <td
                            style={{
                              border: "1px solid #dcdcdc",
                              verticalAlign: "top",
                            }}
                          >
                            {this.props.remisionMuestra.vdt2.volumen} KG
                          </td>
                          <td
                            style={{
                              border: "1px solid #dcdcdc",
                              verticalAlign: "top",
                            }}
                          >
                            {this.props.remisionMuestra.analisis_solicitados}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <br />
                    <br />
                    <br />
                    <br />
                    <br />
                    <br />
                    <table
                      className="table"
                      style={{
                        width: "100%",
                        marginBottom: "1rem",
                        color: "#212529",
                        borderSpacing: 0,
                        borderCollapse: "collapse",
                        tableLayout: "auto",
                      }}
                    >
                      <tbody>
                        <tr>
                          <td
                            colSpan="1"
                            className="table-body-td no-border"
                            style={{
                              padding: 0,
                              verticalAlign: "top",
                            }}
                          >
                            <p className="m-0" style={{ margin: 0 }}>
                              <span
                                className="mr-2"
                                style={{ marginRight: "0.5rem" }}
                              >
                                <b>Firma del Funcionario IPSA/Área:</b>
                              </span>
                              {this.props.remisionMuestra.remitente.nombre}
                            </p>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  {/*<div className="pdf-retiro-data">
                  <table
                    className="table"
                    style={{
                     /* width: "100%",
                      marginBottom: "1rem",
                      color: "#212529",
                      borderSpacing: 0,
                      borderCollapse: "collapse",
                      tableLayout: "auto",
                    }}
                  >
                    <thead>
                      <tr>
                        <td
                          colSpan="3"
                          className="table-header-td text-center"
                          style={{
                            backgroundColor: "#dcdcdc",
                            textAlign: "center",
                            padding: 0,
                            verticalAlign: "top",
                          }}
                        >
                          <b>III. Retiro del Resultado / Uso del Laboratorio</b>
                        </td>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td
                          colSpan="1"
                          className="table-body-td no-border"
                          style={{
                            padding: 0,
                            verticalAlign: "top",
                          }}
                        >
                          <p className="m-0" style={{ margin: 0 }}>
                            <span
                              className="mr-2"
                              style={{ marginRight: "0.5rem" }}
                            >
                              <b>Fecha de Retiro:</b>
                            </span>
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td
                          width="33.333%"
                          colSpan="1"
                          className="table-body-td no-border"
                          style={{
                            padding: 0,
                            verticalAlign: "top",
                          }}
                        >
                          <p className="m-0" style={{ margin: 0 }}>
                            <span
                              className="mr-2"
                              style={{ marginRight: "0.5rem" }}
                            >
                              <b>Persona que retira:</b>
                            </span>
                          </p>
                        </td>
                      </tr>

                      <tr>
                        <td
                          width="33.333%"
                          colSpan="1"
                          className="table-body-td no-border"
                          style={{
                            padding: 0,
                            verticalAlign: "top",
                          }}
                        >
                          <p className="m-0" style={{ margin: 0 }}>
                            <span
                              className="mr-2"
                              style={{ marginRight: "0.5rem" }}
                            >
                              <b>Persona que Entrega:</b>
                            </span>
                          </p>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                        </div>*/}

                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />

                  <div
                    className="pdf-footer"
                    style={{
                      bottom: 0,
                    }}
                  >
                    <table
                      className="table footer-table "
                      style={{
                        fontSize: "11px",
                        color: "#9e9a9a",
                        width: "100%",
                        marginBottom: "1rem",
                        borderSpacing: 0,
                        borderCollapse: "collapse",
                        marginLeft: "auto",
                        marginRight: "auto",
                        tableLayout: "auto",
                      }}
                    >
                      <tbody>
                        <tr>
                          <td
                            width="70%"
                            className="no-border text-center"
                            style={{
                              border: "none",
                              textAlign: "center",
                              verticalAlign: "top",
                            }}
                          >
                            Instituto de Protección y Sanidad Agropecuraria
                            (IPSA) <br />
                            Dirección Km 5&#189; Carretera Norte, contiguo a
                            ENACAL Portezuelo, Managua
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </form>
              </div>

              <hr />
            </div>
          </ModalBody>
          <ModalFooter>
            <ReactToPrint
              content={() => componentRef.current}
              pageStyle=""
              trigger={() => (
                <button id="btn-imprimir" className="btn btn-primary m-r-5">
                  Imprimir
                </button>
              )}
              // onBeforeGetContent={() =>
              //   this.props.imprimir(
              //     this.props.licencia.licencia_id,
              //     this.props.licencia.tramite_id,
              //     this.props.licencia.impresiones
              //   )
              // }
            />
            <button
              className="btn btn-danger"
              onClick={this.props.closeModalHojaRemision}
            >
              Regresar
            </button>
          </ModalFooter>
        </Modal>
      </>
    );
  }
}
export default HojaRemisionMuestra;